
export default function SQLs_Where() {
  return (
    <div>
      <h1>SQL Where</h1>
      <p>Content for SQL Where will go here.</p>
    </div>
  );
}
